import React from "react";
import { forgotPasswordSchema } from "../../validationSchemas/forgotPasswordSchema";
import { FormField } from "../FormFields/FormField";
import { Formik } from "formik";
import { ForgotPasswordFormFields } from "../../models/forms.model";
import ReCAPTCHA from "react-google-recaptcha";
import { RECAPTCHA_SITE_KEY } from "../../constants";

interface IHandleSubmission {
  handleFormSubmission: (
    values: ForgotPasswordFormFields,
    { setSubmitting }
  ) => void;
  invalidEmailMessage: string;
  handleInvalidEmailMessage: () => void;
  recaptchaRef: any;
  invalidRecaptchaMessage: string;
  showReCAPTCHA: boolean;
}

const ForgotPasswordForm = (props: IHandleSubmission) => {
  const initialFormState: ForgotPasswordFormFields = {
    email: "",
  };

  const { invalidEmailMessage, handleInvalidEmailMessage, recaptchaRef, handleFormSubmission, invalidRecaptchaMessage, showReCAPTCHA } = props;

  return (
    <Formik
      onSubmit={handleFormSubmission}
      initialValues={initialFormState}
      validationSchema={forgotPasswordSchema}
    >
      {({
        isSubmitting,
        errors,
        touched,
        handleChange,
        handleSubmit,
        submitForm,
      }) => (
        <form onSubmit={handleSubmit}>
          <FormField
            labelText={"EMAIL ADDRESS"}
            name="email"
            type="email"
            onChange={(e) => {
              handleInvalidEmailMessage();
              handleChange(e);
            }}
            errors={errors}
            touched={touched}
            inputFieldClass={invalidEmailMessage ? "input_error" : ""}
          />
          <span className="clr-dark-red f-s16 font-rale">
            {invalidEmailMessage}
          </span>
          {
            showReCAPTCHA &&
            <>
              <hr className="my-4 d-none d-md-block" />
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={RECAPTCHA_SITE_KEY}
                onChange={handleInvalidEmailMessage}
              />
              <span className="clr-dark-red f-s16 font-rale">
                {invalidRecaptchaMessage}
              </span>
            </>
          }
          <div className="max-content mx-auto pt-4">
            <button
              type="submit"
              id="reset-password-button"
              className={`btn btn-large d-block ${invalidEmailMessage || isSubmitting ? "dark-grey" : ""
                }`}
              disabled={isSubmitting || Boolean(invalidEmailMessage)}
              onClick={(event: any) => {
                event.preventDefault()
                submitForm()
              }}
            >
              reset password
            </button>
          </div>
        </form>
      )}
    </Formik>
  );
};
export default ForgotPasswordForm;